import { useParams } from "react-router-dom";

import { ProductContent } from "./components";
import { useProductDetail } from "./hooks";

export const ProductDetailPage = () => {
  const { productId } = useParams();

  const { product, isLoading, hasSubscribe } = useProductDetail(
    Number(productId),
  );
  return (
    <ProductContent
      product={product}
      isLoading={isLoading}
      hasSubscribe={hasSubscribe}
    />
  );
};
